import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Grid,
  DialogContent,
  DialogActions,
  DialogTitle,
  Dialog,
  Typography,
  List,
  ListItemText,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTransition from "@icarius-common/dialogTransition";
import PaperDraggable from "@icarius-common/paperDraggable";

const ScaleWarningDialog = (props) => {

  const {
    open,
    code,
    handleClose,
  } = props;

  return (
    <Dialog
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      open={open}
      scroll={"paper"}
      fullWidth
      maxWidth={"sm"}>
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        {getLocalizedString("atention")}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogContent style={{ paddingTop: 0 }}>
        {code ?
          <>
            <Grid container item xs={12}>
              <Typography className="whiteText" style={{ width: '100%', textAlign: 'justify', padding: '0px 10px' }}>
                {getLocalizedString("scaleWarningDialogLine1", { code: code })}
              </Typography>
            </Grid>
          </> :
          <>
            <Grid container item xs={12}>
              <Typography className="whiteText" style={{ width: '100%', textAlign: 'justify', padding: '0px 10px' }}>
                {getLocalizedString("scaleWarningDialogLine2")}
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <Typography className="whiteText" style={{ width: '100%', padding: '0px 10px' }}>
                {`${getLocalizedString("forExample")}:`}
              </Typography>
            </Grid>
            <Grid container item xs={12} style={{ marginTop: 10 }}>
              <Typography className="whiteText" style={{ weight: 300, width: '100%', padding: '0px 10px' }}>
                {`${getLocalizedString("goals")}:`}
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <List>
                <ListItemText className="truncate pl-8 whiteText" primary={`1. ${getLocalizedString("lowerThanExpected")}     10,00`} disableTypography={true} />
                <ListItemText className="truncate pl-8 whiteText" primary={`2. ${getLocalizedString("asExpected")}          20,00`} disableTypography={true} />
                <ListItemText className="truncate pl-8 whiteText" primary={`3. ${getLocalizedString("aboveExpected")}    30,00`} disableTypography={true} />
              </List>
            </Grid>
            <Grid container item xs={12} style={{ marginTop: 10 }}>
              <Typography className="whiteText" style={{ weight: 300, width: '100%', padding: '0px 10px' }}>
                {`${getLocalizedString("competencies")}:`}
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <List>
                <ListItemText className="truncate pl-8 whiteText" primary={`1. ${getLocalizedString("poor")}           10,00`} disableTypography={true} />
                <ListItemText className="truncate pl-8 whiteText" primary={`2. ${getLocalizedString("fair")}        15,00`} disableTypography={true} />
                <ListItemText className="truncate pl-8 whiteText" primary={`3. ${getLocalizedString("good")}          20,00`} disableTypography={true} />
                <ListItemText className="truncate pl-8 whiteText" primary={`4. ${getLocalizedString("veryGood")}      30,00`} disableTypography={true} />
              </List>
            </Grid>
          </>
        }
      </DialogContent>
      <DialogActions>
        <ButtonDialogAction onClick={handleClose} isAccept text={getLocalizedString("accept")} />
      </DialogActions>
    </Dialog>
  );
}

export default ScaleWarningDialog;
